export default __webpack_public_path__ + "files/d63692bd2453c244295d1b88530fb3d8.mp3";